import JobsPage from '../../js/pages/JobsPage';

export default JobsPage;
